module.exports = __webpack_public_path__ + "src/assets/images/volums/wind_speed/volum_circle5.png?d192401a27bdf4b10b034c4ef414d1a8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volums/wind_speed/volum_circle5.png
// module id = 823
// module chunks = 0